import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const ResultAction = styled.div`
  border-radius: 2px;
  background-color: #003399;
  cursor: pointer;
  display: flex;
  align-items: center;
  float: left;
  color: #fafafa;
  padding: 5px;
  font-size: 10px;
  margin-right: 7px;
  margin-bottom: 8px;
  min-height: 24px;

  @media (max-width: ${breakpoints.bpDesktopPx}) {
    clear: both;
  }
`

export default ResultAction
